.message {
  align-items: flex-start;
  background-color: var(--ui-color-info-bg);
  border-radius: var(--ui-border-radius-md);
  box-shadow: inset 0 0 0 1px var(--message-inner-border-color);
  color: var(--ui-color-text);
  display: flex;
  font-size: var(--ui-font-size-s);
  line-height: var(--ui-line-height-base);
  margin: 0;
  padding: var(--ui-space-md);
  position: relative;
  text-wrap: balance;
  z-index: 1;
}

.content {
  /* 2px padding to align with icons */
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 2px var(--ui-space-md) 0 0;
}

.content--no-top-padding {
  padding-top: 0;
}

.small {
  display: inline-flex;
  justify-content: center;
  padding: 6px var(--ui-space-md);
  text-align: center;
}

.small .content {
  padding: 0;
}

ui-attention-icon {
  padding-right: var(--ui-space-md);
}

.close {
  cursor: pointer;
  position: absolute;
  right: var(--ui-space-xs);
  top: var(--ui-space-xs);
}

.action {
  cursor: pointer;
  display: inline-block;
  line-height: var(--ui-line-height-l);
  text-decoration: underline;
  text-transform: uppercase;
}

.error {
  background-color: var(--ui-color-error-bg);
}

.error .action {
  border-color: var(--ui-color-error);
  color: var(--ui-color-error);
}

.success {
  background-color: var(--ui-color-success-bg);
}

.success .action {
  border-color: var(--ui-color-success);
  color: var(--ui-color-success);
}

.warning {
  background-color: var(--ui-color-warning-bg);
}

.warning .action {
  border-color: var(--ui-color-warning);
  color: var(--ui-color-warning);
}

.info {
  background-color: var(--ui-color-info-bg);
}

.info .action {
  border-color: var(--ui-color-info);
  color: var(--ui-color-info);
}
